var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FE9901;}\n\t.st1{fill:#2F2317;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:none;stroke:#2F2317;stroke-width:16;stroke-linecap:round;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 268.7,
  cy: 272.7,
  r: 262.3
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 387.1,
  cy: 191.5,
  r: 38.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 402.2,
  cy: 179.1,
  r: 9.6
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st1",
  cx: 150,
  cy: 190.9,
  r: 38.3
}), /*#__PURE__*/React.createElement("circle", {
  className: "st2",
  cx: 165.1,
  cy: 178.6,
  r: 9.6
})), /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M336.2,284.3c0,0-68-45.3-135.9,0"
}));

function SvgMood2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 540 540",
    style: {
      enableBackground: "new 0 0 540 540"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMood2);
export default __webpack_public_path__ + "static/media/mood2.f07a2ae4298a499c5429d6562a112ec9.svg";
export { ForwardRef as ReactComponent };